let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7TI3f")).then(() => parcelRequire('d9mMk'));